import equal from 'fast-deep-equal/react';
import { DivTooltip, Interpolate } from '@wg/wows-react-uikit';
import classnames from 'classnames';
import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { playButtonDialogClickSound } from '@wg/web2clientapi/sound';
import styles from './TopCounter.scss';
import type { RootState } from '~/store';
import { useAppDispatch, useAppSelector } from '~/hooks';
import CountDown from '~/Components/CountDown/CountDown';
import { openRulesDialog } from '~/store/dialogs';
import { appIsReady } from '~/selectors';
import { RulesButtonTooltip } from '~/Components/Tooltips/Tooltips';
import preloaded from '~/preloaded';

export interface TopCounterState {
    appIsReady: boolean,
    progressFinishTime: number,
}

const stateSelector = (state: RootState) => {
    return {
        appIsReady: appIsReady(state),
        progressFinishTime: state.app.progressFinishTime,
    };
};

const TopCounter = () => {
    const { t } = useTranslation();
    const state = useAppSelector(stateSelector, equal);
    const dispatch = useAppDispatch();
    const { appIsReady, progressFinishTime } = state;
    const local = preloaded.settings.languageCode;
    const dateFinishString = new Date(progressFinishTime).toLocaleString(local, {
        month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
    });

    const wrapperClassname = classnames(styles.wrapper, {
        [styles.wrapperVisible]: appIsReady,
    });

    const openRules = useCallback(() => {
        playButtonDialogClickSound();
        dispatch(openRulesDialog());
    }, [dispatch]);

    const button = useMemo(() => {
        return (
            <DivTooltip tooltipBody={<RulesButtonTooltip />}>
                <div className={styles.rulesButton} onClick={openRules}>
                    {t('Правила события')}
                </div>
            </DivTooltip>
        );
    }, [openRules, t]);

    return (
        <div className={wrapperClassname}>
            {progressFinishTime > Date.now() && (
                <CountDown
                    date={progressFinishTime}
                    tooltipText={<Interpolate str={t('Боевые задачи верфи доступны до: %(value)s')} value={dateFinishString} />}
                />
            )}
            <div className={styles.rulesButtonWrapper}>{button}</div>
        </div>
    );
};

export default memo(TopCounter);
